import * as React from "react";

const MenuFocused: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="currentColor">
            <g fill="none" fillRule="evenodd">
                <rect width="30" height="30" fill="currentColor" rx="2" />
                <path
                    fill="#FFF"
                    fillRule="nonzero"
                    d="M13.9852319,0.263793808 C14.3757562,-0.126730484 15.0089212,-0.126730484 15.3994455,0.263793808 L15.4987971,0.363145411 C15.8893214,0.753669703 15.8893214,1.38683468 15.4987971,1.77735897 L9.394,7.881 L15.7362062,14.222641 C16.1267305,14.6131653 16.1267305,15.2463303 15.7362062,15.6368546 L15.6368546,15.7362062 C15.2463303,16.1267305 14.6131653,16.1267305 14.222641,15.7362062 L7.881,9.394 L1.77735897,15.4987971 C1.41687501,15.859281 0.849643956,15.8870106 0.457352749,15.5819857 L0.363145411,15.4987971 L0.263793808,15.3994455 C-0.126730484,15.0089212 -0.126730484,14.3757562 0.263793808,13.9852319 L6.367,7.881 L0.501202936,2.0147681 C0.110678644,1.62424381 0.110678644,0.991078831 0.501202936,0.600554539 L0.600554539,0.501202936 C0.991078831,0.110678644 1.62424381,0.110678644 2.0147681,0.501202936 L7.881,6.367 Z"
                    transform="translate(7 7)"
                />
            </g>
        </svg>
    );
};

export default React.memo(MenuFocused);
